const slick = require('slick-carousel');

const slickJs = function () {

    $(document).ready(function () {

        $('.slick-carousel').slick({
            dots: true,
            infinite: true,
            speed: 450,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: true,
            mobileFirst: true,
            responsive: [
                // {
                //     breakpoint: 992,
                //     settings: {
                //         slidesToShow: 3,
                //         slidesToScroll: 3,
                //         infinite: true,
                //         dots: true
                //     }
                // },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                // },
                // {
                //     breakpoint: 576,
                //     settings: {
                //         slidesToShow: 1,
                //         slidesToScroll: 1,
                //         centerMode: true,
                //         centerPadding: '40px'
                //     }
                }
            ]
        });

        $('.slick-carousel-quotes').slick({
            dots: true,
            infinite: false,
            speed: 450,
            slidesToShow: 1,
            slidesToScroll: 1,
            // autoplay: true,
            // autoplaySpeed: 3000,
            arrows: true
        });
    });
}

export default slickJs;
